import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { Person } from 'UI';
import '../../Verdict.scss';

var VerdictDisplayFeedback = /*#__PURE__*/function (_Component) {
  _inherits(VerdictDisplayFeedback, _Component);

  var _super = _createSuper(VerdictDisplayFeedback);

  function VerdictDisplayFeedback() {
    _classCallCheck(this, VerdictDisplayFeedback);

    return _super.apply(this, arguments);
  }

  _createClass(VerdictDisplayFeedback, [{
    key: "render",
    value: function render() {
      var feedback = '';

      if (this.props.verdict != null) {
        feedback = this.props.verdict.feedback;
      } else if (this.props.feedback != null) {
        feedback = this.props.feedback;
      } else if (this.props.value != null) {
        feedback = this.props.value;
      }

      if (feedback != null && feedback != '') {
        feedback = feedback.replace(/(\r\n|\r|\n)/g, '<br />');
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "verdict verdict-feedback-display"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text"
      }, this.props.user != null ? /*#__PURE__*/React.createElement(Person, {
        person: this.props.user
      }, /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: feedback
        }
      })) : /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: feedback
        }
      })));
    }
  }]);

  return VerdictDisplayFeedback;
}(Component);

export default VerdictDisplayFeedback;